import { render, staticRenderFns } from "./SignupReviewDialog.vue?vue&type=template&id=6e0caaf2"
import script from "./SignupReviewDialog.vue?vue&type=script&lang=ts"
export * from "./SignupReviewDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports